/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

export const filterContextItemsBySearch = ({ items, query, getSearchText }) => {
  const normalizedQuery = query?.trim()?.toLowerCase();

  if (!normalizedQuery) {
    return items ?? [];
  }

  if (typeof getSearchText !== 'function') {
    return items ?? [];
  }

  return (items ?? []).filter(item => {
    const searchText = getSearchText(item);

    return String(searchText ?? '')
      .toLowerCase()
      .includes(normalizedQuery);
  });
};
